"use client";

import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import { IBlocks, IConnections } from "@/types";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import React from "react";
import { startsWithHTTPS } from "@/lib/utils";
import { toast } from "sonner";
import { Label } from "@/components/ui/label";
import {
    IconBrandTiktok,
    IconBrandTwitch,
    IconBrandTwitter,
    IconBrandYoutube,
} from "@tabler/icons-react";
import CardSetting from "@/components/admin/settings/CardSetting";
import {
    Popover,
    PopoverContent,
    PopoverTrigger,
} from "@/components/ui/popover";
import { ColorPicker } from "@/components/admin/content/ColorPicker";

interface Props {
    block: IBlocks;
    blockUpdate: React.Dispatch<React.SetStateAction<IBlocks>>;
    update: (value: IBlocks) => void;
    connections: {
        id: string;
        provider:
        | "twitch"
        | "youtube"
        | "twitter"
        | "bluesky"
        | "threads"
        | "instagram"
        | "tiktok"
        | "trovo";
        data: {
            [key: string]: any;
        };
    }[];
}

export default function MediaKitOptions({
    block,
    blockUpdate,
    update,
    connections,
}: Props) {
    const [oldBlock, setOldBlock] = React.useState(block);
    if (!block.options.data) {
        block.options.data = [];
    }
    return (
        <div className="flex w-full flex-col gap-3">
            <CardSetting
                title={<div className="px-3">Platforms</div>}
                className=""
                noBorder
            >
                <div className="flex w-full flex-col gap-3">
                    {connections.map((connection, index) => {
                        let checked_check = false;
                        const found = block.options?.data.find(
                            (e: any) => e.id === connection.id
                        );
                        if (found) {
                            checked_check = true;
                        }
                        return (
                            <div key={index}>
                                <CardSetting
                                    noBorder
                                    className="bg-accent/30"
                                    title={
                                        <div className="flex w-full items-center justify-between">
                                            <div className="flex w-full items-center gap-3">
                                                {connection.provider ===
                                                    "youtube" && (
                                                        <>
                                                            <IconBrandYoutube />
                                                        </>
                                                    )}
                                                {connection.provider ===
                                                    "twitch" && (
                                                        <>
                                                            <IconBrandTwitch />
                                                        </>
                                                    )}
                                                {connection.provider ===
                                                    "twitter" && (
                                                        <>
                                                            <IconBrandTwitter />
                                                        </>
                                                    )}
                                                {connection.provider ===
                                                    "tiktok" && (
                                                        <>
                                                            <IconBrandTiktok />
                                                        </>
                                                    )}
                                                {connection.provider ===
                                                    "trovo" && (
                                                        <>
                                                            <img
                                                                src="https://cdn.doras.to/doras/icons/light/trovo.png"
                                                                className="h-[24px] w-[24px]"
                                                                alt="Trovo"
                                                            />{" "}
                                                        </>
                                                    )}
                                                {connection.data.username}
                                            </div>
                                            <Switch
                                                checked={checked_check}
                                                onCheckedChange={(checked) => {
                                                    let newData;
                                                    if (checked) {
                                                        if (
                                                            connection.provider ===
                                                            "youtube"
                                                        ) {
                                                            newData = [
                                                                ...block.options
                                                                    .data,
                                                                {
                                                                    id: connection.id,
                                                                    total_views:
                                                                        true,
                                                                    recent_views:
                                                                        true,
                                                                    viewer_approval:
                                                                        true,
                                                                    subscriber_change:
                                                                        true,
                                                                    average_watch_duration:
                                                                        true,
                                                                },
                                                            ];
                                                        }
                                                        if (
                                                            connection.provider ===
                                                            "twitch"
                                                        ) {
                                                            newData = [
                                                                ...block.options
                                                                    .data,
                                                                {
                                                                    id: connection.id,
                                                                    subscribers:
                                                                        true,
                                                                    average_viewers:
                                                                        true,
                                                                    recent_followers:
                                                                        true,
                                                                    hours_watched:
                                                                        true,
                                                                    recent_games:
                                                                        true,
                                                                },
                                                            ];
                                                        }
                                                        if (
                                                            connection.provider ===
                                                            "twitter"
                                                        ) {
                                                            newData = [
                                                                ...block.options
                                                                    .data,
                                                                {
                                                                    id: connection.id,
                                                                    followers:
                                                                        true,
                                                                    following:
                                                                        true,
                                                                    tweets: true,
                                                                    likes: true,
                                                                },
                                                            ];
                                                        }
                                                        if (
                                                            connection.provider ===
                                                            "tiktok"
                                                        ) {
                                                            newData = [
                                                                ...block.options
                                                                    .data,
                                                                {
                                                                    id: connection.id,
                                                                    followers:
                                                                        true,
                                                                    following:
                                                                        true,
                                                                    videos: false,
                                                                    likes: false,
                                                                    recent_views:
                                                                        false,
                                                                    recent_likes:
                                                                        false,
                                                                },
                                                            ];
                                                        }
                                                        if (
                                                            connection.provider ===
                                                            "trovo"
                                                        ) {
                                                            newData = [
                                                                ...block.options
                                                                    .data,
                                                                {
                                                                    id: connection.id,
                                                                    followers:
                                                                        true,
                                                                    subscribers:
                                                                        true,
                                                                },
                                                            ];
                                                        }
                                                    } else {
                                                        newData =
                                                            block.options.data.filter(
                                                                (e: any) =>
                                                                    e.id !==
                                                                    connection.id
                                                            );
                                                    }
                                                    update({
                                                        ...block,
                                                        options: {
                                                            ...block.options,
                                                            data: newData,
                                                        },
                                                    });
                                                }}
                                            />
                                        </div>
                                    }
                                >
                                    {found && (
                                        <div className="flex flex-col gap-3">
                                            <Separator />
                                            <div className="">
                                                {connection.provider ===
                                                    "youtube" && (
                                                        <div className="flex w-full flex-col gap-3">
                                                            <div className="flex w-full items-center justify-between">
                                                                <Label>
                                                                    Total views
                                                                </Label>
                                                                <Switch
                                                                    checked={
                                                                        found.total_views
                                                                    }
                                                                    onCheckedChange={(
                                                                        checked
                                                                    ) => {
                                                                        update({
                                                                            ...block,
                                                                            options:
                                                                            {
                                                                                ...block.options,
                                                                                data: block.options.data.map(
                                                                                    (
                                                                                        e: any
                                                                                    ) => {
                                                                                        if (
                                                                                            e.id ===
                                                                                            connection.id
                                                                                        ) {
                                                                                            return {
                                                                                                ...e,
                                                                                                total_views:
                                                                                                    checked,
                                                                                            };
                                                                                        }
                                                                                        return e;
                                                                                    }
                                                                                ),
                                                                            },
                                                                        });
                                                                    }}
                                                                />
                                                            </div>
                                                            <div className="flex w-full items-center justify-between">
                                                                <Label>
                                                                    Recent views
                                                                </Label>
                                                                <Switch
                                                                    checked={
                                                                        found.recent_views
                                                                    }
                                                                    onCheckedChange={(
                                                                        checked
                                                                    ) => {
                                                                        update({
                                                                            ...block,
                                                                            options:
                                                                            {
                                                                                ...block.options,
                                                                                data: block.options.data.map(
                                                                                    (
                                                                                        e: any
                                                                                    ) => {
                                                                                        if (
                                                                                            e.id ===
                                                                                            connection.id
                                                                                        ) {
                                                                                            return {
                                                                                                ...e,
                                                                                                recent_views:
                                                                                                    checked,
                                                                                            };
                                                                                        }
                                                                                        return e;
                                                                                    }
                                                                                ),
                                                                            },
                                                                        });
                                                                    }}
                                                                />
                                                            </div>
                                                            <div className="flex w-full items-center justify-between">
                                                                <Label>
                                                                    Viewer approval
                                                                </Label>
                                                                <Switch
                                                                    checked={
                                                                        found.viewer_approval
                                                                    }
                                                                    onCheckedChange={(
                                                                        checked
                                                                    ) => {
                                                                        update({
                                                                            ...block,
                                                                            options:
                                                                            {
                                                                                ...block.options,
                                                                                data: block.options.data.map(
                                                                                    (
                                                                                        e: any
                                                                                    ) => {
                                                                                        if (
                                                                                            e.id ===
                                                                                            connection.id
                                                                                        ) {
                                                                                            return {
                                                                                                ...e,
                                                                                                viewer_approval:
                                                                                                    checked,
                                                                                            };
                                                                                        }
                                                                                        return e;
                                                                                    }
                                                                                ),
                                                                            },
                                                                        });
                                                                    }}
                                                                />
                                                            </div>
                                                            <div className="flex w-full items-center justify-between">
                                                                <Label>
                                                                    Subscriber
                                                                    change
                                                                </Label>
                                                                <Switch
                                                                    checked={
                                                                        found.subscriber_change
                                                                    }
                                                                    onCheckedChange={(
                                                                        checked
                                                                    ) => {
                                                                        update({
                                                                            ...block,
                                                                            options:
                                                                            {
                                                                                ...block.options,
                                                                                data: block.options.data.map(
                                                                                    (
                                                                                        e: any
                                                                                    ) => {
                                                                                        if (
                                                                                            e.id ===
                                                                                            connection.id
                                                                                        ) {
                                                                                            return {
                                                                                                ...e,
                                                                                                subscriber_change:
                                                                                                    checked,
                                                                                            };
                                                                                        }
                                                                                        return e;
                                                                                    }
                                                                                ),
                                                                            },
                                                                        });
                                                                    }}
                                                                />
                                                            </div>
                                                            <div className="flex w-full items-center justify-between">
                                                                <Label>
                                                                    Average watch
                                                                    duration
                                                                </Label>
                                                                <Switch
                                                                    checked={
                                                                        found.average_watch_duration
                                                                    }
                                                                    onCheckedChange={(
                                                                        checked
                                                                    ) => {
                                                                        update({
                                                                            ...block,
                                                                            options:
                                                                            {
                                                                                ...block.options,
                                                                                data: block.options.data.map(
                                                                                    (
                                                                                        e: any
                                                                                    ) => {
                                                                                        if (
                                                                                            e.id ===
                                                                                            connection.id
                                                                                        ) {
                                                                                            return {
                                                                                                ...e,
                                                                                                average_watch_duration:
                                                                                                    checked,
                                                                                            };
                                                                                        }
                                                                                        return e;
                                                                                    }
                                                                                ),
                                                                            },
                                                                        });
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>
                                                    )}
                                                {connection.provider ===
                                                    "twitch" && (
                                                        <div className="flex w-full flex-col gap-3">
                                                            <div className="flex w-full items-center justify-between">
                                                                <Label>
                                                                    Subscribers
                                                                </Label>
                                                                <Switch
                                                                    checked={
                                                                        found.subscribers
                                                                    }
                                                                    onCheckedChange={(
                                                                        checked
                                                                    ) => {
                                                                        update({
                                                                            ...block,
                                                                            options:
                                                                            {
                                                                                ...block.options,
                                                                                data: block.options.data.map(
                                                                                    (
                                                                                        e: any
                                                                                    ) => {
                                                                                        if (
                                                                                            e.id ===
                                                                                            connection.id
                                                                                        ) {
                                                                                            return {
                                                                                                ...e,
                                                                                                subscribers:
                                                                                                    checked,
                                                                                            };
                                                                                        }
                                                                                        return e;
                                                                                    }
                                                                                ),
                                                                            },
                                                                        });
                                                                    }}
                                                                />
                                                            </div>
                                                            <div className="flex w-full items-center justify-between">
                                                                <Label>
                                                                    Average viewers
                                                                </Label>
                                                                <Switch
                                                                    checked={
                                                                        found.average_viewers
                                                                    }
                                                                    onCheckedChange={(
                                                                        checked
                                                                    ) => {
                                                                        update({
                                                                            ...block,
                                                                            options:
                                                                            {
                                                                                ...block.options,
                                                                                data: block.options.data.map(
                                                                                    (
                                                                                        e: any
                                                                                    ) => {
                                                                                        if (
                                                                                            e.id ===
                                                                                            connection.id
                                                                                        ) {
                                                                                            return {
                                                                                                ...e,
                                                                                                average_viewers:
                                                                                                    checked,
                                                                                            };
                                                                                        }
                                                                                        return e;
                                                                                    }
                                                                                ),
                                                                            },
                                                                        });
                                                                    }}
                                                                />
                                                            </div>
                                                            <div className="flex w-full items-center justify-between">
                                                                <Label>
                                                                    Recent followers
                                                                </Label>
                                                                <Switch
                                                                    checked={
                                                                        found.recent_followers
                                                                    }
                                                                    onCheckedChange={(
                                                                        checked
                                                                    ) => {
                                                                        update({
                                                                            ...block,
                                                                            options:
                                                                            {
                                                                                ...block.options,
                                                                                data: block.options.data.map(
                                                                                    (
                                                                                        e: any
                                                                                    ) => {
                                                                                        if (
                                                                                            e.id ===
                                                                                            connection.id
                                                                                        ) {
                                                                                            return {
                                                                                                ...e,
                                                                                                recent_followers:
                                                                                                    checked,
                                                                                            };
                                                                                        }
                                                                                        return e;
                                                                                    }
                                                                                ),
                                                                            },
                                                                        });
                                                                    }}
                                                                />
                                                            </div>
                                                            <div className="flex w-full items-center justify-between">
                                                                <Label>
                                                                    Hours watched
                                                                </Label>
                                                                <Switch
                                                                    checked={
                                                                        found.hours_watched
                                                                    }
                                                                    onCheckedChange={(
                                                                        checked
                                                                    ) => {
                                                                        update({
                                                                            ...block,
                                                                            options:
                                                                            {
                                                                                ...block.options,
                                                                                data: block.options.data.map(
                                                                                    (
                                                                                        e: any
                                                                                    ) => {
                                                                                        if (
                                                                                            e.id ===
                                                                                            connection.id
                                                                                        ) {
                                                                                            return {
                                                                                                ...e,
                                                                                                hours_watched:
                                                                                                    checked,
                                                                                            };
                                                                                        }
                                                                                        return e;
                                                                                    }
                                                                                ),
                                                                            },
                                                                        });
                                                                    }}
                                                                />
                                                            </div>
                                                            {/* <div className="flex w-full items-center justify-between">
                                                            <Label>
                                                                Recent games
                                                            </Label>
                                                            <Switch
                                                                checked={
                                                                    found.recent_games
                                                                }
                                                                onCheckedChange={(
                                                                    checked
                                                                ) => {
                                                                    update({
                                                                        ...block,
                                                                        options:
                                                                            {
                                                                                ...block.options,
                                                                                data: block.options.data.map(
                                                                                    (
                                                                                        e: any
                                                                                    ) => {
                                                                                        if (
                                                                                            e.id ===
                                                                                            connection.id
                                                                                        ) {
                                                                                            return {
                                                                                                ...e,
                                                                                                recent_games:
                                                                                                    checked,
                                                                                            };
                                                                                        }
                                                                                        return e;
                                                                                    }
                                                                                ),
                                                                            },
                                                                    });
                                                                }}
                                                            />
                                                        </div> */}
                                                        </div>
                                                    )}
                                                {connection.provider ===
                                                    "twitter" && (
                                                        <div className="flex w-full flex-col gap-3">
                                                            <div className="flex w-full items-center justify-between">
                                                                <Label>
                                                                    Followers
                                                                </Label>
                                                                <Switch
                                                                    checked={
                                                                        found.followers
                                                                    }
                                                                    onCheckedChange={(
                                                                        checked
                                                                    ) => {
                                                                        update({
                                                                            ...block,
                                                                            options:
                                                                            {
                                                                                ...block.options,
                                                                                data: block.options.data.map(
                                                                                    (
                                                                                        e: any
                                                                                    ) => {
                                                                                        if (
                                                                                            e.id ===
                                                                                            connection.id
                                                                                        ) {
                                                                                            return {
                                                                                                ...e,
                                                                                                followers:
                                                                                                    checked,
                                                                                            };
                                                                                        }
                                                                                        return e;
                                                                                    }
                                                                                ),
                                                                            },
                                                                        });
                                                                    }}
                                                                />
                                                            </div>
                                                            <div className="flex w-full items-center justify-between">
                                                                <Label>
                                                                    Following
                                                                </Label>
                                                                <Switch
                                                                    checked={
                                                                        found.following
                                                                    }
                                                                    onCheckedChange={(
                                                                        checked
                                                                    ) => {
                                                                        update({
                                                                            ...block,
                                                                            options:
                                                                            {
                                                                                ...block.options,
                                                                                data: block.options.data.map(
                                                                                    (
                                                                                        e: any
                                                                                    ) => {
                                                                                        if (
                                                                                            e.id ===
                                                                                            connection.id
                                                                                        ) {
                                                                                            return {
                                                                                                ...e,
                                                                                                following:
                                                                                                    checked,
                                                                                            };
                                                                                        }
                                                                                        return e;
                                                                                    }
                                                                                ),
                                                                            },
                                                                        });
                                                                    }}
                                                                />
                                                            </div>
                                                            <div className="flex w-full items-center justify-between">
                                                                <Label>
                                                                    Tweets
                                                                </Label>
                                                                <Switch
                                                                    checked={
                                                                        found.tweets
                                                                    }
                                                                    onCheckedChange={(
                                                                        checked
                                                                    ) => {
                                                                        update({
                                                                            ...block,
                                                                            options:
                                                                            {
                                                                                ...block.options,
                                                                                data: block.options.data.map(
                                                                                    (
                                                                                        e: any
                                                                                    ) => {
                                                                                        if (
                                                                                            e.id ===
                                                                                            connection.id
                                                                                        ) {
                                                                                            return {
                                                                                                ...e,
                                                                                                tweets: checked,
                                                                                            };
                                                                                        }
                                                                                        return e;
                                                                                    }
                                                                                ),
                                                                            },
                                                                        });
                                                                    }}
                                                                />
                                                            </div>
                                                            <div className="flex w-full items-center justify-between">
                                                                <Label>Likes</Label>
                                                                <Switch
                                                                    checked={
                                                                        found.likes
                                                                    }
                                                                    onCheckedChange={(
                                                                        checked
                                                                    ) => {
                                                                        update({
                                                                            ...block,
                                                                            options:
                                                                            {
                                                                                ...block.options,
                                                                                data: block.options.data.map(
                                                                                    (
                                                                                        e: any
                                                                                    ) => {
                                                                                        if (
                                                                                            e.id ===
                                                                                            connection.id
                                                                                        ) {
                                                                                            return {
                                                                                                ...e,
                                                                                                likes: checked,
                                                                                            };
                                                                                        }
                                                                                        return e;
                                                                                    }
                                                                                ),
                                                                            },
                                                                        });
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>
                                                    )}
                                                {connection.provider ===
                                                    "tiktok" && (
                                                        <div className="flex w-full flex-col gap-3">
                                                            <div className="flex w-full items-center justify-between">
                                                                <Label>
                                                                    Followers
                                                                </Label>
                                                                <Switch
                                                                    checked={
                                                                        found.followers
                                                                    }
                                                                    onCheckedChange={(
                                                                        checked
                                                                    ) => {
                                                                        update({
                                                                            ...block,
                                                                            options:
                                                                            {
                                                                                ...block.options,
                                                                                data: block.options.data.map(
                                                                                    (
                                                                                        e: any
                                                                                    ) => {
                                                                                        if (
                                                                                            e.id ===
                                                                                            connection.id
                                                                                        ) {
                                                                                            return {
                                                                                                ...e,
                                                                                                followers:
                                                                                                    checked,
                                                                                            };
                                                                                        }
                                                                                        return e;
                                                                                    }
                                                                                ),
                                                                            },
                                                                        });
                                                                    }}
                                                                />
                                                            </div>
                                                            <div className="flex w-full items-center justify-between">
                                                                <Label>
                                                                    Following
                                                                </Label>
                                                                <Switch
                                                                    checked={
                                                                        found.following
                                                                    }
                                                                    onCheckedChange={(
                                                                        checked
                                                                    ) => {
                                                                        update({
                                                                            ...block,
                                                                            options:
                                                                            {
                                                                                ...block.options,
                                                                                data: block.options.data.map(
                                                                                    (
                                                                                        e: any
                                                                                    ) => {
                                                                                        if (
                                                                                            e.id ===
                                                                                            connection.id
                                                                                        ) {
                                                                                            return {
                                                                                                ...e,
                                                                                                following:
                                                                                                    checked,
                                                                                            };
                                                                                        }
                                                                                        return e;
                                                                                    }
                                                                                ),
                                                                            },
                                                                        });
                                                                    }}
                                                                />
                                                            </div>
                                                            <div className="flex w-full items-center justify-between">
                                                                <Label>
                                                                    Videos
                                                                </Label>
                                                                <Switch
                                                                    checked={
                                                                        found.videos
                                                                    }
                                                                    onCheckedChange={(
                                                                        checked
                                                                    ) => {
                                                                        update({
                                                                            ...block,
                                                                            options:
                                                                            {
                                                                                ...block.options,
                                                                                data: block.options.data.map(
                                                                                    (
                                                                                        e: any
                                                                                    ) => {
                                                                                        if (
                                                                                            e.id ===
                                                                                            connection.id
                                                                                        ) {
                                                                                            return {
                                                                                                ...e,
                                                                                                videos: checked,
                                                                                            };
                                                                                        }
                                                                                        return e;
                                                                                    }
                                                                                ),
                                                                            },
                                                                        });
                                                                    }}
                                                                />
                                                            </div>
                                                            <div className="flex w-full items-center justify-between">
                                                                <Label>Likes</Label>
                                                                <Switch
                                                                    checked={
                                                                        found.likes
                                                                    }
                                                                    onCheckedChange={(
                                                                        checked
                                                                    ) => {
                                                                        update({
                                                                            ...block,
                                                                            options:
                                                                            {
                                                                                ...block.options,
                                                                                data: block.options.data.map(
                                                                                    (
                                                                                        e: any
                                                                                    ) => {
                                                                                        if (
                                                                                            e.id ===
                                                                                            connection.id
                                                                                        ) {
                                                                                            return {
                                                                                                ...e,
                                                                                                likes: checked,
                                                                                            };
                                                                                        }
                                                                                        return e;
                                                                                    }
                                                                                ),
                                                                            },
                                                                        });
                                                                    }}
                                                                />
                                                            </div>
                                                            <div className="flex w-full items-center justify-between">
                                                                <Label>
                                                                    Recent Views
                                                                </Label>
                                                                <Switch
                                                                    checked={
                                                                        found.recent_views
                                                                    }
                                                                    onCheckedChange={(
                                                                        checked
                                                                    ) => {
                                                                        update({
                                                                            ...block,
                                                                            options:
                                                                            {
                                                                                ...block.options,
                                                                                data: block.options.data.map(
                                                                                    (
                                                                                        e: any
                                                                                    ) => {
                                                                                        if (
                                                                                            e.id ===
                                                                                            connection.id
                                                                                        ) {
                                                                                            return {
                                                                                                ...e,
                                                                                                recent_views:
                                                                                                    checked,
                                                                                            };
                                                                                        }
                                                                                        return e;
                                                                                    }
                                                                                ),
                                                                            },
                                                                        });
                                                                    }}
                                                                />
                                                            </div>
                                                            <div className="flex w-full items-center justify-between">
                                                                <Label>
                                                                    Recent Likes
                                                                </Label>
                                                                <Switch
                                                                    checked={
                                                                        found.recent_likes
                                                                    }
                                                                    onCheckedChange={(
                                                                        checked
                                                                    ) => {
                                                                        update({
                                                                            ...block,
                                                                            options:
                                                                            {
                                                                                ...block.options,
                                                                                data: block.options.data.map(
                                                                                    (
                                                                                        e: any
                                                                                    ) => {
                                                                                        if (
                                                                                            e.id ===
                                                                                            connection.id
                                                                                        ) {
                                                                                            return {
                                                                                                ...e,
                                                                                                recent_likes:
                                                                                                    checked,
                                                                                            };
                                                                                        }
                                                                                        return e;
                                                                                    }
                                                                                ),
                                                                            },
                                                                        });
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>
                                                    )}
                                                {connection.provider ===
                                                    "trovo" && (
                                                        <div className="flex w-full flex-col gap-3">
                                                            <div className="flex w-full items-center justify-between">
                                                                <Label>
                                                                    Followers
                                                                </Label>
                                                                <Switch
                                                                    checked={
                                                                        found.followers
                                                                    }
                                                                    onCheckedChange={(
                                                                        checked
                                                                    ) => {
                                                                        update({
                                                                            ...block,
                                                                            options:
                                                                            {
                                                                                ...block.options,
                                                                                data: block.options.data.map(
                                                                                    (
                                                                                        e: any
                                                                                    ) => {
                                                                                        if (
                                                                                            e.id ===
                                                                                            connection.id
                                                                                        ) {
                                                                                            return {
                                                                                                ...e,
                                                                                                followers:
                                                                                                    checked,
                                                                                            };
                                                                                        }
                                                                                        return e;
                                                                                    }
                                                                                ),
                                                                            },
                                                                        });
                                                                    }}
                                                                />
                                                            </div>
                                                            <div className="flex w-full items-center justify-between">
                                                                <Label>
                                                                    Subscribers
                                                                </Label>
                                                                <Switch
                                                                    checked={
                                                                        found.subscribers
                                                                    }
                                                                    onCheckedChange={(
                                                                        checked
                                                                    ) => {
                                                                        update({
                                                                            ...block,
                                                                            options:
                                                                            {
                                                                                ...block.options,
                                                                                data: block.options.data.map(
                                                                                    (
                                                                                        e: any
                                                                                    ) => {
                                                                                        if (
                                                                                            e.id ===
                                                                                            connection.id
                                                                                        ) {
                                                                                            return {
                                                                                                ...e,
                                                                                                subscribers:
                                                                                                    checked,
                                                                                            };
                                                                                        }
                                                                                        return e;
                                                                                    }
                                                                                ),
                                                                            },
                                                                        });
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>
                                                    )}
                                            </div>
                                            <div className="flex items-center justify-between gap-4">
                                                <Label variant="toggle">
                                                    Custom theme
                                                </Label>
                                                <Switch
                                                    onCheckedChange={(
                                                        checked
                                                    ) =>
                                                        update({
                                                            ...block,
                                                            options: {
                                                                ...block.options,
                                                                data: block.options.data.map(
                                                                    (
                                                                        e: any
                                                                    ) => {
                                                                        if (
                                                                            e.id ===
                                                                            connection.id
                                                                        ) {
                                                                            return {
                                                                                ...e,
                                                                                theme: checked,
                                                                            };
                                                                        }
                                                                        return e;
                                                                    }
                                                                ),
                                                            },
                                                        })
                                                    }
                                                    checked={found.theme}
                                                />
                                            </div>
                                            {found.theme && (
                                                <>
                                                    <div className="flex items-center justify-between gap-4">
                                                        <div className="">
                                                            <Label>
                                                                Background
                                                            </Label>
                                                        </div>
                                                        <Popover>
                                                            <PopoverTrigger
                                                                asChild
                                                            >
                                                                <Button
                                                                    className="h-9 w-9 rounded-full border-2 border-primary"
                                                                    style={{
                                                                        background:
                                                                            found.background_colour,
                                                                    }}
                                                                ></Button>
                                                            </PopoverTrigger>
                                                            <PopoverContent className="z-[999]">
                                                                <ColorPicker
                                                                    value={
                                                                        found.background_colour
                                                                    }
                                                                    onChange={(
                                                                        value: string
                                                                    ) => {
                                                                        update({
                                                                            ...block,
                                                                            options:
                                                                            {
                                                                                ...block.options,
                                                                                data: block.options.data.map(
                                                                                    (
                                                                                        e: any
                                                                                    ) => {
                                                                                        if (
                                                                                            e.id ===
                                                                                            connection.id
                                                                                        ) {
                                                                                            return {
                                                                                                ...e,
                                                                                                background_colour:
                                                                                                    value,
                                                                                            };
                                                                                        }
                                                                                        return e;
                                                                                    }
                                                                                ),
                                                                            },
                                                                        });
                                                                    }}
                                                                />
                                                            </PopoverContent>
                                                        </Popover>
                                                    </div>
                                                    <div className="flex items-center justify-between gap-4">
                                                        <div className="">
                                                            <Label>
                                                                Text color
                                                            </Label>
                                                        </div>
                                                        <Popover>
                                                            <PopoverTrigger
                                                                asChild
                                                            >
                                                                <Button
                                                                    className="h-9 w-9 rounded-full border-2 border-primary"
                                                                    style={{
                                                                        background:
                                                                            found.text_colour,
                                                                    }}
                                                                ></Button>
                                                            </PopoverTrigger>
                                                            <PopoverContent className="z-[999]">
                                                                <ColorPicker
                                                                    value={
                                                                        found.text_colour
                                                                    }
                                                                    onChange={(
                                                                        value: string
                                                                    ) => {
                                                                        update({
                                                                            ...block,
                                                                            options:
                                                                            {
                                                                                ...block.options,
                                                                                data: block.options.data.map(
                                                                                    (
                                                                                        e: any
                                                                                    ) => {
                                                                                        if (
                                                                                            e.id ===
                                                                                            connection.id
                                                                                        ) {
                                                                                            return {
                                                                                                ...e,
                                                                                                text_colour:
                                                                                                    value,
                                                                                            };
                                                                                        }
                                                                                        return e;
                                                                                    }
                                                                                ),
                                                                            },
                                                                        });
                                                                    }}
                                                                />
                                                            </PopoverContent>
                                                        </Popover>
                                                    </div>
                                                </>
                                            )}
                                        </div>
                                    )}
                                </CardSetting>
                            </div>
                        );
                    })}
                </div>
            </CardSetting>
            <CardSetting title="Options" noBorder>
                <div className="flex w-full flex-col gap-3">
                    <div className="flex w-full items-center justify-between">
                        <Label>Show total followers</Label>
                        <Switch
                            checked={block.options.total_followers}
                            onCheckedChange={(checked) =>
                                update({
                                    ...block,
                                    options: {
                                        ...block.options,
                                        total_followers: checked,
                                    },
                                })
                            }
                        />
                    </div>
                </div>
            </CardSetting>
        </div>
    );
}
